import React, { Dispatch, useContext, FC } from 'react';
import { Link } from 'react-router-dom';
import { RiShoppingCart2Fill } from 'react-icons/ri';
import HamburgerMenu from '../HamburgerMenu/HamburgerMenu';
import Search from '../Search/Search';
import styles from './Header.module.scss';
import { Context } from '../../Context/Context';
import { CartContext } from '../../Context/CartContext/CartContext';
import { types } from '../../Context/Reducers/Reducer';
import Modal from '../Modal/Modal';
import Authentication from '../Authentication/Authentication';

interface Props {
  isOpen: boolean,
  setIsOpen: Dispatch<React.SetStateAction<boolean>>
}

const Header: FC<Props> = ({ isOpen, setIsOpen }) => {
  const { user, state, dispatch } = useContext(Context);
  const { state: { cartItems } } = useContext(CartContext);

  const toggleModal = () => {
    dispatch({
      type: types.SHOW_MODAL,
    });
  };

  return (
    <>
      <Modal
        show={state.showModal}
        handleClose={toggleModal}
      >
        <Authentication />
      </Modal>
      <div className={styles.headerContainer}>
        <div className={styles.headerTitle}>
          <HamburgerMenu isOpen={isOpen} setIsOpen={setIsOpen} />
          <Link to="/" className={styles.linkStyle}>
            <h3>Little Tags</h3>
          </Link>
        </div>
        <Search />
        <div className={styles.headerAuth}>
          {
            !!user
            && (
              <div className={styles.profile}>
                <img src={user.photoURL} alt="" className={styles.profilePic} />
                <div className={styles.userName}>{user.displayName.split(' ')[0]}</div>
              </div>
            )
          }
          {
            !user
            && (
              <div
                onClick={toggleModal}
                onKeyDown={toggleModal}
                role="button"
                tabIndex={0}
              >
                Log in / Sign up
              </div>
            )
          }
          <Link to="/cart" className={styles.linkStyle}>
            <div className={styles.cart}>
              <span className={styles.badge}>{cartItems.length}</span>
              <RiShoppingCart2Fill size="1.5rem" />
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Header;
